var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, ModelSync, Watch } from 'vue-property-decorator';
import { BRow, BCol, BFormRadioGroup, BFormGroup, BButton, BAlert } from 'bootstrap-vue';
import TabHeading from 'components/picture-frames/Tabs/TabHeading.vue';
import UnitSelector from 'components/UnitSelector.vue';
import SizeInput from 'components/SizeInput.vue';
import StandardSizeSelector from 'components/StandardSizeSelector.vue';
let ArtworkSize = class ArtworkSize extends Vue {
    artworkSize;
    sizeType = 'bespoke';
    sizeTypeOptions = [
        { text: 'Custom Size', value: 'bespoke' },
        { text: 'Standard Size', value: 'standard' },
    ];
    minDimension = 50;
    maxDimension = 2700;
    minRebateDimension = 103;
    displayUnit = 'mm';
    get areDimensionsValid() {
        return this.problems.length === 0 && this.artworkSize.length > 0 && this.artworkSize.width > 0;
    }
    get problems() {
        let problems = [];
        if (Math.max(this.artworkSize.length, this.artworkSize.width) > this.maxDimension) {
            problems.push(`The maximum dimension we are able to manufacture a frame to is ${this.maxDimension}mm`);
        }
        return problems;
    }
    get warnings() {
        let warnings = [];
        if (Math.min(this.artworkSize.length, this.artworkSize.width) < (this.minRebateDimension - 3)) {
            warnings.push(`The minimum rebate size we can manufacture a frame to is ${this.minRebateDimension}mm, therefore we will require you to have a mount with this frame.`);
        }
        return warnings;
    }
    onSizeTypeChange() {
        if (this.sizeType == 'standard') {
            // Default the size to A4 rather than trying to match it up
            this.$emit('change', { width: 210, length: 297, name: 'A4', type: 'a' });
        }
        else if (this.sizeType == 'bespoke') {
            switch (this.artworkSize.type) {
                case 'inch':
                case 'square':
                    this.displayUnit = 'inch';
                    break;
                case 'cm':
                    this.displayUnit = 'cm';
                    break;
                case 'a':
                    this.displayUnit = 'mm';
                    break;
            }
            this.$emit('change', { width: this.artworkSize.width, length: this.artworkSize.length });
        }
    }
    onSizeChange() {
        if (this.sizeType == 'standard' && !this.artworkSize.name) {
            this.sizeType = 'bespoke';
            this.displayUnit = 'mm';
        }
        if (this.artworkSize.length < 1) {
            this.$emit('change', { width: this.artworkSize.width, length: 1 });
        }
        else if (this.artworkSize.width < 1) {
            this.$emit('change', { width: 1, length: this.artworkSize.length });
        }
    }
    mounted() {
        if (this.artworkSize.name) {
            this.sizeType = 'standard';
        }
    }
};
__decorate([
    ModelSync('size', 'change', { type: Object })
], ArtworkSize.prototype, "artworkSize", void 0);
__decorate([
    Watch('artworkSize', { deep: true })
], ArtworkSize.prototype, "onSizeChange", null);
ArtworkSize = __decorate([
    Component({
        components: {
            BFormRadioGroup, BFormGroup, BRow, BCol, BButton, BAlert,
            TabHeading, SizeInput, UnitSelector, StandardSizeSelector
        }
    })
], ArtworkSize);
export default ArtworkSize;
